import React, { useMemo } from 'react'
import './NoEmailIntegration.scss'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { useGetMeQuery } from '../../store/user/user'
import { createState, IntegrationServiceId } from '../../common/integrations'
import Illustration from '../../assets/images/noemailintegration.png'
import { Link } from 'react-router-dom'
import { EmailConnectButton } from '../EmailConnectButton/EmailConnectButton'
import { IntegrationIcon } from '../IntegrationIcon'

export const NoEmailIntegration: React.FC = () => {
  const accountId = useAppSelector(selectAccountId)
  const { data: userData } = useGetMeQuery({ accountId: accountId }, { refetchOnMountOrArgChange: true })
  const hasOtherMailIntegration = useMemo(() => {
    return !!(userData && userData.integrations && userData.integrations.some((i) => i.type === 'mail'))
  }, [userData])

  const state = createState()

  return (
    <div className='d-flex align-items-center justify-content-center w-100'>
      <div className='d-flex flex-column align-self-stretch align-items-center gap-4 no-email-container'>
        <div className='d-flex flex-column align-items-start gap-1 zocks-border-color-gray-100 zocks-bg-color-primary-light rounded-4 pt-3 align-self-stretch no-email-illustration'>
          <img className='w-100 h-100 object-fit-contain' src={Illustration} alt='No Email Integration' />
        </div>
        <div className='d-flex flex-column align-items-center gap-4 align-self-stretch'>
          <div className='d-flex flex-column align-items-stretch gap-1'>
            <div className='text-center h5'>Unlock your AI-powered inbox</div>
            <div className='text-center paragraph-medium'>
              Connect your email account to unlock smart categorization, contextual intelligence, and automated client updates. Turn email overwhelm into
              organized productivity.
            </div>
          </div>
          <div className='d-flex flex-column align-items-center align-self-stretch gap-3'>
            <div className='d-flex align-items-center flex-row gap-3 w-100 px-3'>
              <div className='d-flex justify-content-center align-items-center flex-1'>
                <EmailConnectButton
                  className='flex-1 button-medium'
                  serviceId={IntegrationServiceId.OUTLOOK_MAIL}
                  redirectState={state}
                  hasOtherMailIntegration={hasOtherMailIntegration}
                  variant='secondaryGhostButton'
                >
                  <IntegrationIcon serviceId={IntegrationServiceId.OUTLOOK_MAIL} width={16} height={16} /> Connect Outlook Mail
                </EmailConnectButton>
              </div>
              <div className='d-flex justify-content-center align-items-center flex-1'>
                <EmailConnectButton
                  className='flex-1 button-medium'
                  serviceId={IntegrationServiceId.GMAIL}
                  redirectState={state}
                  hasOtherMailIntegration={hasOtherMailIntegration}
                  variant='secondaryGhostButton'
                >
                  <IntegrationIcon serviceId={IntegrationServiceId.GMAIL} width={16} height={16} /> Connect Gmail
                </EmailConnectButton>
              </div>
            </div>
            <div className='align-self-stretch text-center'>
              <Link className='zocks-text-primary button-link-medium' to='/account/profile-settings/integrations'>
                See all supported providers
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
